import Styled from 'styled-components'


export const Container = Styled.div`
`


export const Paragraph = Styled.div`
`

export const AccordionContent = Styled.div`
`


export const ParagraphDiv = Styled.div`
`